import { getRouteApi, useNavigate } from '@tanstack/react-router'
import { useCreateEnvelopeOnboardingDocuments } from 'commons/hooks/bank/onboardingSetupDocuments'
import { OnboardingDocumentCreateModeWebPage } from 'commons/types/DTO/bank/applications/onboardingDocuments'
import { useConfirmation } from 'ui/components/Dialog/ConfirmationDialogV2'

import { handlerServerError } from '@orbit/errors'

import { ManageContainer } from '../../containers/ManageContainer'

const routeApi = getRouteApi('/_app/application/$applicationId/onboarding-documents/setup')

const SetupDocumentsCreate = () => {
  const navigate = useNavigate()
  const confirmation = useConfirmation()

  const applicationId = routeApi.useParams({ select: (s) => s.applicationId })
  const webPageData: OnboardingDocumentCreateModeWebPage = routeApi.useLoaderData({ select: (s) => s.webPageData })

  const { routine: create } = useCreateEnvelopeOnboardingDocuments({
    onSuccess: () =>
      navigate({
        from: '/application/$applicationId/onboarding-documents/setup',
        to: '/onboarding/applications/$applicationId',
        params: { applicationId: applicationId.toString() }
      }),
    onError: (e) => handlerServerError(e)
  })

  const openCreateConfirmation = async (form) => {
    if (
      await confirmation.showAskConfirmation({
        message: <>Are you sure you want to&nbsp;create the set of&nbsp;onboarding documents?</>,
        confirmCallback: () => create({ ...form, applicationId: Number(applicationId) })
      })
    ) {
      await confirmation.showDoneConfirmation({
        message: <>The set of&nbsp;onboarding documents has been created</>
      })
    }
  }

  return (
    <ManageContainer
      webPageData={webPageData}
      pageTitle={`Application ID-${applicationId}`}
      pageSubTitle="Setup Onboarding Documents"
      onSubmitForm={openCreateConfirmation}
      footerSubmitButtonText="Create Onboarding Documents"
    />
  )
}

export default SetupDocumentsCreate
